// v3.15-1096: AdminRoute — hard guard for admin-only pages. Non-admin
// users (Company Managers, Team Members, VO Officers, etc.) hitting one
// of the protected URLs directly are bounced silently to /clients (the
// safe workspace landing page).  No 403 page; we just refuse to render
// the admin surface.
//
// v3.18-1388 CRM-INT-005 — Previous fallback pointed non-admins at
// /dashboard when they had `canAccessDashboard`.  With the CEO-only
// allow-list that would 404 for everyone but the CEO, so we now route
// unconditionally to /clients.
//
// Used for: Revenue Dashboard, PTC Finance, Payout Approval, Ghost
// Leads, Partner Payroll.
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAdmin, user, loading, authChecked } = useAuth();
  if (loading || (!user && !authChecked)) return null;
  if (!isAdmin()) {
    return <Navigate to="/clients" replace />;
  }
  return children;
};

export default AdminRoute;
